import React, { useState, useEffect } from 'react';
import {
  Card, Form, Input, Button, message, Switch, InputNumber, Space, Typography, Spin
} from 'antd';
import { SoundOutlined, SaveOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { TextArea } = Input;

const AdTickerManager = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchTicker();
  }, []);

  const fetchTicker = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('admin_token');
      const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/settings`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        form.setFieldsValue({
          ticker_enabled: data.ticker_enabled === '1' || data.ticker_enabled === true,
          ticker_text: data.ticker_text || '',
          ticker_duration_hours: parseInt(data.ticker_duration_hours, 10) || 24
        });
      }
    } catch (error) {
      message.error('تعذر جلب بيانات الإعلان الشريطي');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (values) => {
    setSaving(true);
    try {
      const token = localStorage.getItem('admin_token');
      const payload = {
        ticker_enabled: values.ticker_enabled ? '1' : '0',
        ticker_text: values.ticker_text || '',
        ticker_duration_hours: String(values.ticker_duration_hours || 24)
      };
      const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/settings`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        message.success('تم حفظ الإعلان الشريطي بنجاح');
      } else {
        const errorData = await res.json();
        message.error(errorData.message || 'تعذر حفظ الإعلان الشريطي');
      }
    } catch (error) {
      console.error('خطأ في حفظ الإعلان الشريطي:', error);
      message.error('تعذر الاتصال بالخادم');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>;
  }

  return (
    <Card
      title={
        <span>
          <SoundOutlined /> الإعلان الشريطي
        </span>
      }
    >
      <Form form={form} layout="vertical" onFinish={handleSave}>
        <Form.Item
          name="ticker_enabled"
          label="إظهار / إيقاف"
          valuePropName="checked"
          extra={
            <Text type="secondary">عند التفعيل، يظهر شريط متحرك أسفل الهيدر مباشرة.</Text>
          }
        >
          <Switch />
        </Form.Item>

        <Form.Item
          name="ticker_text"
          label="نص الإعلان"
          rules={[{ required: false }]}
        >
          <TextArea
            rows={3}
            placeholder="اكتب نص الإعلان الذي سيظهر متحركاً أسفل الهيدر..."
          />
        </Form.Item>

        <Form.Item
          name="ticker_duration_hours"
          label="مدة الإخفاء (ساعات)"
          extra={
            <Text type="secondary">
              بعد إغلاق الزائر للشريط، لن يظهر له مجدداً إلا بعد هذه المدة (افتراضياً 24 ساعة).
            </Text>
          }
        >
          <InputNumber min={1} max={720} style={{ width: 200 }} addonAfter="ساعة" />
        </Form.Item>

        <Space style={{ marginTop: 8 }}>
          <Button
            type="primary"
            htmlType="submit"
            icon={<SaveOutlined />}
            loading={saving}
          >
            حفظ الإعلان الشريطي
          </Button>
        </Space>
      </Form>
    </Card>
  );
};

export default AdTickerManager;